import $ from "jquery";

export default function milkNotice() {
    window.kkMilkNotice = {};
    window.kkMilkNotice.hasShown = false;
    window.kkMilkNotice.hasInit = false;
    window.kkMilkNotice.show = function handleModal($modal) {
        if(window.kkMilkNotice.hasInit === false) {
            window.kkMilkNotice.hasInit = true;
            const resizeMilkNotice = function () {
                const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                $modal.find(".modal-dialog").width(w - 10);
                $modal.find(".modal-dialog").css("margin", "0 auto");
                $modal.find(".modal-dialog").height(h - 10);
                $modal.find(".modal-content").css("min-height", "100%");
            };

            $modal.find("#closeBreastfeedingnotice").on('click', function (e) {
                if ($modal.find("#dontShowAgain").prop("checked") === true) {
                    Cookies.set("brestfeedingnote", true, {expires: null, secure: true});
                }
            });

            if (!Cookies.get("brestfeedingnote")) {
                window.kkMilkNotice.hasShown = true;
                $modal.modal('show');
            }

            resizeMilkNotice();
            $(window).on('resize', function () {
                resizeMilkNotice();
            });
        }
    }
}
